import { render } from "./MunicipioUf.vue?vue&type=template&id=621ae1fa&ts=true"
import script from "./MunicipioUf.vue?vue&type=script&lang=ts"
export * from "./MunicipioUf.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__